import { jsx as e } from "react/jsx-runtime";
import { forwardRef as h } from "react";
import { R as d, I as n } from "../../index-CHHAYd53.js";
import { c as k } from "../../cn-gv_k3DnN.js";
import { focusRing as l } from "../../utils/focus-ring.js";
import { Icon as o } from "../icon/icon.js";
const s = h(({ checked: c, className: r, hasError: a, ...t }, b) => /* @__PURE__ */ e(
  d,
  {
    ref: b,
    checked: c,
    className: k(
      // Base
      "size-s-3 rounded-xs border-(--color-checkbox-stroke-unchecked) bg-(--color-checkbox-bg-unchecked) peer relative flex shrink-0 items-center justify-center border",
      // Checked
      "enabled:data-[state=checked]:border-(--color-checkbox-bg-checked) enabled:data-[state=checked]:bg-(--color-checkbox-bg-checked) enabled:data-[state=checked]:text-(--color-checkbox-content-checked)",
      // Indeterminate
      "enabled:data-[state=indeterminate]:border-(--color-checkbox-bg-checked)  enabled:data-[state=indeterminate]:bg-(--color-checkbox-bg-checked)  enabled:data-[state=indeterminate]:text-(--color-checkbox-content-checked)",
      // Hover
      "enabled:hover:bg-(--color-checkbox-bg-unchecked-hover) enabled:hover:data-[state=checked]:border-(--color-checkbox-bg-checked-hover) enabled:hover:data-[state=indeterminate]:border-(--color-checkbox-bg-checked-hover) enabled:hover:data-[state=checked]:bg-(--color-checkbox-bg-checked-hover) enabled:hover:data-[state=indeterminate]:bg-(--color-checkbox-bg-checked-hover]",
      // Disabled
      "disabled:border-(--color-checkbox-stroke-unchecked-disabled) disabled:bg-(--color-checkbox-bg-unchecked-disabled) disabled:text-(--color-checkbox-content-checked-disabled) disabled:data-[state=checked]:border-(--color-checkbox-bg-unchecked-disabled) disabled:data-[state=indeterminate]:border-(--color-checkbox-bg-unchecked-disabled]",
      // Error
      {
        "border-(--color-checkbox-stroke-danger) enabled:data-[state=indeterminate]:border-(--color-checkbox-stroke-danger) enabled:data-[state=checked]:border-(--color-checkbox-stroke-danger)": a
      },
      // Focus
      l,
      r
    ),
    ...t,
    children: /* @__PURE__ */ e(n, { children: c === "indeterminate" ? /* @__PURE__ */ e(o, { size: "sm", name: "minus" }) : /* @__PURE__ */ e(o, { size: "sm", name: "check" }) })
  }
));
s.displayName = d.displayName;
export {
  s as Checkbox
};
